import { css } from '@emotion/react';
import { DesignToken, SpacingToken } from '@livechat/design-system-react-components';

import { MEDIA_MAX_XSS } from '_assets/css/breakpoints';

export const requirementsContainer = css`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  gap: var(${SpacingToken.Spacing4});
  width: 100%;
  margin-bottom: var(${SpacingToken.Spacing5});

  ${MEDIA_MAX_XSS} {
    flex-direction: column;
    gap: var(${SpacingToken.Spacing1});
  }
`;

export const requirementsColumn = css`
  max-width: max-content;
  display: flex;
  flex-direction: column;
  gap: var(${SpacingToken.Spacing1});
  flex: 1;
  color: var(${DesignToken.ContentBasicDisabled});
`;

const getRequirementColor = (isValid: boolean, showError: boolean) => {
  if (showError && !isValid) return `var(${DesignToken.ContentBasicNegative})`;
  if (isValid) return `var(${DesignToken.ContentBasicPositive})`;
  return 'inherit';
};

export const requirement = (isValid: boolean, showError: boolean = false) => css`
  display: flex;
  align-items: center;
  gap: var(${SpacingToken.Spacing2});
  color: ${getRequirementColor(isValid, showError)};

  svg {
    color: ${getRequirementColor(isValid, showError)};
  }
`;
